import type { Percent, Seconds } from "@core/types";
import { asPercent } from "@core/types";
import { CALM_REFILL_RATE, GLOW_DRAIN_RATE } from "@data/balance";

export { GLOW_DRAIN_RATE, CALM_REFILL_RATE };

const clampPercent = (v: number): Percent => asPercent(Math.min(100, Math.max(0, v)));

/** Входные данные для расчёта энергии за тик. */
export interface EnergyUpdateInput {
  energy: Percent;
  glow: boolean;
  inCalmSpot: boolean;
  dt: Seconds;
}

/** Результат расчёта энергии — включает transition-флаги для EventBus. */
export interface EnergyUpdateResult {
  energy: Percent;
  depletedTransition: boolean; // true если в этом тике стало 0
  fullTransition: boolean; // true если в этом тике стало 100
}

/** Чистая функция расчёта новой энергии за тик. */
export const updateEnergy = (input: EnergyUpdateInput): EnergyUpdateResult => {
  const { energy, glow, inCalmSpot, dt } = input;
  let next = energy as number;
  if (glow) next = next - GLOW_DRAIN_RATE * dt;
  if (inCalmSpot && next < 100) next = next + CALM_REFILL_RATE * dt;
  const clamped = clampPercent(next);
  return {
    energy: clamped,
    depletedTransition: (energy as number) > 0 && (clamped as number) <= 0,
    fullTransition: (energy as number) < 100 && (clamped as number) >= 100,
  };
};
